import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import "./Banner.css";
import { getHomeBanners } from "../../../utils/apis/homepage";
import { IDS } from "../../../utils/common";
import Enquire_from_modal from "../../common-components/common_modal/enquire_from_modal/Enquire_from_modal";

function Banner() {
  const [banner, setBanner] = useState([]);
  const [modalShow, setModalShow] = useState(false);

  const getBanner = async () => {
    const res = await getHomeBanners();

    if (res?.success) {
      setBanner(res.data);
    }
  };

  useEffect(() => {
    getBanner();
  }, []);

  return (
    <section className="home-banner">
      <div className="container-fluid p-0">
        <Swiper
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination, Autoplay]}
          className="mySwiper"
        >
          {banner?.map((item, index) => {
            const file = IDS?.IMG_URL + item?.image;

            const isVideo =
              file.endsWith(".mp4") ||
              file.endsWith(".webm") ||
              file.endsWith(".ogg");

            return (
              <SwiperSlide key={item?.id || index}>
                <div className="banner-div">

                  {/* IMAGE / VIDEO */}
                  {isVideo ? (
                    <video
                      className="banner-video"
                      src={file}
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  ) : (
                    <img
                      className="banner-img"
                      src={file}
                      alt={`home-banner-${index + 1}`}
                    />
                  )}

                  {/* FULL BANNER OVERLAY */}
                  <div className="banner-overlay">
                    {/* Optional Banner Content */}
                    {/* 
                    <div className="banner-content">
                      <h1>
                        Empowering Farmers with <br />
                        <span>Quality Agricultural Solutions</span>
                      </h1>

                      <div className="banner-btns">
                        <a
                          href="/products"
                          className="banner-btn primary-btn"
                        >
                          Explore Products
                        </a>

                        <button
                          type="button"
                          onClick={() => setModalShow(true)}
                          className="banner-btn secondary-btn"
                        >
                          Become a Dealer
                        </button>
                      </div>
                    </div>
                    */}
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>

      {/* MOBILE BUTTONS */}
      <div className="mobile-btns">
        <a href="/products" className="mobile-btn primary-btn">
          Explore Products
        </a>

        <button
          type="button"
          onClick={() => setModalShow(true)}
          className="mobile-btn second-btn"
        >
          Become a Dealer
        </button>
      </div>

      <Enquire_from_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </section>
  );
}

export default Banner;